enum tokenName {
    ACCESS_TOKEN = "accessToken",
    REFRESH_TOKEN = "refreshToken"
}

export default tokenName;